import { ChevronRightIcon } from "@heroicons/react/16/solid";
import StatisticsCards from "../StatisticsCards";
import { Text } from "../tailwind/text";
import { calculateRate } from "../../functions/calculateRate";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const DashboardRevenue = ({ dataCustomer, isMobile, integrations }) => {
  const initialStats = [
    { name: "WhatsApp cost", value: null },
    { name: "Optins", value: null },
    { name: "Sent", value: null },
    { name: "Deliverability", value: null },
    { name: "Open rate", value: null },
  ];

  if (integrations?.shopify) {
    initialStats.unshift(
      { name: "Turnover", value: null },
      { name: "ARPC", value: null },
    );
    initialStats.splice(3, 0, { name: "ROI", value: null });
  }

  const [stats, setStats] = useState(initialStats);
  useEffect(() => {
    if (!dataCustomer || !dataCustomer?.customerStats) return;

    const customerStats = dataCustomer.customerStats;

    const {
      optins30days,
      optinsTotal,
      optoutCount30days,
      turnover30days,
      externalTurnover30days,
      totalWhatsappCostInEuros30days,
      sent30days,
      read30days,
      delivered30days,
    } = customerStats;

    const openRate =
      sent30days && read30days
        ? calculateRate(read30days, delivered30days).toFixed(0)
        : null;
    const deliveredRate =
      sent30days && read30days
        ? calculateRate(delivered30days, sent30days).toFixed(0)
        : null;

    const stats = [
      {
        name: "WhatsApp cost",
        value: totalWhatsappCostInEuros30days
          ? totalWhatsappCostInEuros30days.toFixed(2) + "€"
          : "-",
        tooltip: true,
        isClickable: false,
        tooltipContent: "The total cost of all WhatsApp messages sent.",
        // changeType:
        //   totalWhatsappCostInEuros30days > 5 ? "positive" : "negative",
        // change: ((totalWhatsappCostInEuros30days ?? 0) - 5).toFixed(2) + "€",
      },
      {
        name: "Optins",
        value: optinsTotal ? optinsTotal : "0",
        tooltip: true,
        isClickable: false,
        tooltipContent:
          "The number of contacts who agreed to receive marketing messages.",
        changeType:
          optins30days - optoutCount30days >= 0 ? "positive" : "negative",
        change:
          (optins30days - optoutCount30days >= 0 ? "+" : "") +
          (optins30days - optoutCount30days).toString(),
      },
      {
        name: "Sent",
        value: sent30days ? sent30days : "-",
        tooltip: true,
        isClickable: false,
        tooltipContent:
          "Number of campaigns and automations sent to recipients.",
      },
      {
        name: "Deliverability",
        value: deliveredRate ? deliveredRate + "%" : "-",
        tooltip: true,
        isClickable: false,
        tooltipContent:
          "The percentage of sent messages that were successfully delivered.",
        ...(deliveredRate > 96 &&
          deliveredRate <= 98 && {
            changeType: "positive",
            change: "Top 5% Performer",
          }),
        ...(deliveredRate > 97 && {
          changeType: "positive",
          change: "Top 5% Performer",
        }),
      },
      {
        name: "Open rate",
        value: openRate ? openRate + "%" : "-",
        tooltip: true,
        isClickable: false,
        tooltipContent:
          "The percentage of sent messages that were actually opened by recipients.",
        ...(openRate > 87 &&
          openRate <= 92 && {
            changeType: "positive",
            change: "Top 5% Performer",
          }),
        ...(openRate > 92 && {
          changeType: "positive",
          change: "Top 1% Performer",
        }),
      },
    ];

    if (integrations?.shopify) {
      stats.unshift(
        {
          name: "Turnover",
          value: turnover30days
            ? turnover30days.toFixed(0) + "€"
            : externalTurnover30days
              ? externalTurnover30days.toFixed(0) + "€"
              : "-",
          tooltip: true,
          tooltipContent: "The total revenue attributed to WhatsApp.",
          isClickable: false,
          // changeType:
          //   (turnover30days ?? 0) > (turnoverLastMounth ?? 0)
          //     ? "positive"
          //     : "negative",
          // change: `${(turnover30days ?? 0) - (turnoverLastMounth ?? 0) > 0 ? "+" : ""}${(turnover30days ?? 0) - (turnoverLastMounth ?? 0)}€`,
        },
        {
          name: "ARPC",
          value:
            sent30days && turnover30days
              ? (turnover30days / Math.max(1, sent30days)).toFixed(2) + "€"
              : "-",
          isClickable: false,
          tooltip: true,
          tooltipContent:
            "Average Revenue Per Conversation: turnover divided by sent messages.",
          ...(sent30days &&
            turnover30days &&
            turnover30days / Math.max(1, sent30days) > 5 &&
            turnover30days / Math.max(1, sent30days) <= 8 && {
              changeType: "positive",
              change: "Top 5% Performer",
            }),
          ...(sent30days &&
            turnover30days &&
            turnover30days / Math.max(1, sent30days) > 8 && {
              changeType: "positive",
              change: "Top 1% Performer",
            }),
        },
      );

      stats.splice(3, 0, {
        name: "ROI",
        value:
          totalWhatsappCostInEuros30days && turnover30days
            ? (
                turnover30days / Math.max(1, totalWhatsappCostInEuros30days)
              ).toFixed(2)
            : "-",
        isClickable: false,
        tooltip: true,
        tooltipContent: "Turnover divided by WhatsApp cost.",
        ...(totalWhatsappCostInEuros30days &&
          turnover30days &&
          turnover30days / Math.max(1, totalWhatsappCostInEuros30days) > 30 &&
          turnover30days / Math.max(1, totalWhatsappCostInEuros30days) <=
            50 && {
            changeType: "positive",
            change: "Top 5% Performer",
          }),
        ...(totalWhatsappCostInEuros30days &&
          turnover30days &&
          turnover30days / Math.max(1, totalWhatsappCostInEuros30days) > 50 && {
            changeType: "positive",
            change: "Top 1% Performer",
          }),
      });
    }

    setStats(stats);
  }, [dataCustomer?.customerStats]);

  return (
    <div className=" my-4 md:mx-0">
      <div className="flex justify-between items-center">
        <Link
          to="/analytics"
          className="flex items-center mb-5 hover:underline"
        >
          <Text className="text-xl font-bold ">Analytics</Text>
          <ChevronRightIcon className="h-7 w-7" />
        </Link>
        <Text className="text-sm mb-5">Last 30 days</Text>
      </div>
      <StatisticsCards stats={stats} is4ByLine={true} isMobile={isMobile} />
    </div>
  );
};
